export default __webpack_public_path__ + "static/media/terms.8c8d7dff.md";